/**
 * WebSocket-URL des Cortex-Chat-Streams (TQ #409).
 * Geteiltes Cockpit: cortexBaseURL ist ein absoluter Origin (https://cortex.…) -> wss://host/api/v1/chat/stream
 * (wie bisher). Pfad-Instanz: cortexBaseURL ist relativ (/<kennung>/cortex) -> gleiches Origin, Pfad bleibt
 * erhalten: wss://cockpit.…/<kennung>/cortex/api/v1/chat/stream (Ingress StripPrefix /<kennung>/cortex).
 */
export function cortexStreamUrl(cortexBaseURL: string, pageHref: string): string {
  const u = new URL(cortexBaseURL, pageHref)
  const scheme = u.protocol === 'https:' ? 'wss:' : 'ws:'
  const path = u.pathname.replace(/\/+$/, '')
  return `${scheme}//${u.host}${path}/api/v1/chat/stream`
}
